import {Component, Injector} from "@angular/core";
import {
    AbstractMultiSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";

@Component({
    selector: "wbo-stock-movement-multi-select-search-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(StockMovementMultiSelectEditControlComponent)
    ]
})
export class StockMovementMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);

        this.buildData([
            {label: "wbo.stock.option.movement.override-level", value: "0"},
            {label: "wbo.stock.option.movement.stock-take", value: "1"},
            {label: "wbo.stock.option.movement.receive-order", value: "2"},
            {label: "wbo.stock.option.movement.credit-order", value: "3"},
            {label: "wbo.stock.option.movement.sale", value: "4"},
            {label: "wbo.stock.option.movement.waste", value: "5"},
            {label: "wbo.stock.option.movement.void", value: "6"},
            {label: "wbo.stock.option.movement.bo-transfer", value: "7"},
            {label: "wbo.stock.option.movement.pos-transfer", value: "8"},
            {label: "wbo.stock.option.movement.table-void", value: "9"},
            {label: "wbo.stock.option.movement.tab-void", value: "10"},
            {label: "wbo.stock.option.movement.tab-order", value: "11"},
            {label: "wbo.stock.option.movement.table-order", value: "12"},
            {label: "wbo.stock.option.movement.refund", value: "14"},
            {label: "wbo.stock.option.movement.supplier-invoice", value: "15"},
            {label: "wbo.stock.option.movement.credit-invoice", value: "19"},
            {label: "wbo.stock.option.movement.value-override", value: "16"},
            {label: "wbo.stock.option.movement.process-recipe", value: "18"}
        ]);
    }
}
